import { render, staticRenderFns } from "./mktBox.vue?vue&type=template&id=4ef4cc48&"
import script from "./mktBox.vue?vue&type=script&lang=js&"
export * from "./mktBox.vue?vue&type=script&lang=js&"
import style0 from "./mktBox.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports